var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.clazz,attrs:{"title":_vm.text},on:{"click":function($event){$event.preventDefault();return _vm.$emit('onClick')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }